import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { ApplicationListParams } from '../model/application-list-params';
import * as applicationList from '../actions/application-list.actions';
import * as application from '../actions/application.actions';
import { Globals } from '../../../app.globals';
import { ModuleRoutingConstants } from '../../../core/helpers/module-routing.constants';
import * as routerActions from '../../../core/actions/router.actions';
import { Params } from '@angular/router/src/shared';
import { pageInfoFromQueryParams } from '../../shared/helper/router-params';

import { ofRoute, ofRouteExit } from '../../../core/router/route-operator';
import { map } from 'rxjs/operators';


@Injectable()
export class ApplicationEffects {

    @Effect() routeChangeIn$ = this.actions$.pipe(
        ofRoute(ModuleRoutingConstants.APPLICATIONS),
        map((action: routerActions.RouteChange) => new applicationList.ChangeParamsAction(this.parseOrDefaults(action.payload.queryParams)))
    );

    /**
     * Side effect to clean module state when navigation out of module.
     */
    @Effect() routeChangeOut$ = this.actions$.pipe(
        ofRouteExit(ModuleRoutingConstants.APPLICATIONS),
        map(() => new application.ClearStoreAction())
    );

    /**
     * Method prepares ApplicationListParams for data retrieval.
     * @param {Params} queryParams
     * @return {ApplicationListParams}
     */
    private parseOrDefaults = (queryParams: Params): ApplicationListParams => {
        const pageInfo = pageInfoFromQueryParams(queryParams, Globals.itemsPerPage.common);
        return new ApplicationListParams(pageInfo.page, pageInfo.itemsPerPage);
    }

    constructor(private actions$: Actions) {}

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/effects/application.effects.ts